import { useAuthStore } from '~/modules/auth/stores/authStore';
import { useAuth } from '~/modules/auth/uses/useAuth';
import { useVisitorStore } from '~/modules/visitors/stores/visitorStore';
import { useFavorites } from '~/uses/useFavorites';
import { useCart } from '~/modules/cart/uses/useCart';
import { isSharedCachedRoute } from '~/constants/cache';

export default defineNuxtPlugin(async (nuxtApp) => {

  // На общих (CDN/nginx) кэшируемых маршрутах НЕ выполняем персональный bootstrap
  // на СЕРВЕРЕ: иначе visitorID/профиль/корзина попадут в SSR-payload, который
  // общий кэш раздаст другим пользователям (источник 403 на favorites и утечки PII).
  // Клиент по-прежнему выполняет bootstrap после гидрации со своей cookie, поэтому
  // хедер/счётчики/избранное наполняются корректно и по-юзерно.
  // Список кэшируемых маршрутов синхронизирован с routeRules в nuxt.config.ts.
  if (import.meta.server && isSharedCachedRoute(useRequestURL().pathname)) {
    return;
  }

  const authStore = useAuthStore();
  const {
    setupCurrentUser,
  } = useAuth();

  const visitorStore = useVisitorStore();

  const { updateCount, updateList } = useFavorites();

  const { setupCartCount } = useCart();

  // Сначала устанавливаем visitor (и его cookie), и только потом остальной bootstrap.
  // Бэкенд (TrackApiVisitor) создаёт НОВОГО визитора на каждом api-эндпоинте без cookie,
  // поэтому параллельные auth/me + cart/count + visitors/current у нового пользователя
  // минтят РАЗНЫХ визиторов: cookie достаётся одному, а visitorID берётся из
  // visitors/current — рассинхрон приводит к ownership-mismatch 403 на favorites.
  // Последовательный запуск фиксирует единый visitor_token до остальных запросов.
  try {
    await visitorStore.setupVisitorID();
  } catch (e) {
    console.error(e);
  }

  await Promise.allSettled([
    setupCurrentUser(),
    setupCartCount(),
  ]);

  if (import.meta.client && visitorStore.visitorID) {
    updateList(visitorStore.visitorID);
    updateCount(visitorStore.visitorID);
  }
});
